import { usePal, PalHead, PalIcon } from "./PalUI";
import { pillarColors } from "../../data/slides";

const PalOpportunity = () => {
  const { c, ink, muted, hair } = usePal();
  const o = c.opportunity;
  return (
    <section aria-label={o.eyebrow} data-testid="pal-opportunity">
      <PalHead eyebrow={o.eyebrow} title={o.title} accentLine={o.accentLine} lead={o.lead} />
      <ul className={`mt-12 pt-8 border-t grid grid-cols-1 md:grid-cols-3 gap-8 ${hair}`}>
        {o.themes.map((t, i) => (
          <li key={t.title} className="flex items-center gap-4" data-testid={`pal-theme-${i}`}>
            <PalIcon name={t.iconName} className={`w-6 h-6 flex-shrink-0 ${muted}`} />
            <h3 className={`text-[19px] font-semibold tracking-tight leading-snug ${ink}`}>{t.title}</h3>
          </li>
        ))}
      </ul>
      <dl className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {o.pillars.map((p) => (
          <div key={p.id} className="border-t-2 pt-4" style={{ borderColor: pillarColors[p.id] }} data-testid={`pal-pillar-${p.id}`}>
            <dt className={`text-[14px] font-bold tracking-wide ${ink}`}>{p.name}</dt>
            <dd className={`mt-1 text-[15px] ${muted}`}>{p.benefit}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default PalOpportunity;
